import React, { useState, useEffect } from 'react'

const TIMER_KEY = 'resend_timer'

const ResendEmailTimer = ({ sendVerificationEmail, email }) => {
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    const timerKeyForUser = `${TIMER_KEY}_${email}`
    const expireTime = localStorage.getItem(timerKeyForUser)
    const currentTime = Date.now()

    if (expireTime) {
      const timeDiff = Math.floor((expireTime - currentTime) / 1000)
      if (timeDiff > 0) {
        setCounter(timeDiff)
      }
    }
  }, [])

  useEffect(() => {
    let timer
    if (counter > 0) {
      timer = setInterval(() => {
        setCounter(prevCounter => prevCounter - 1)
      }, 1000)
    }

    return () => {
      if (timer) clearInterval(timer)
    }
  }, [counter])

  const handleResendClick = async e => {
    if (e) e.preventDefault()

    if (counter > 0) {
      return
    }

    const success = await sendVerificationEmail(e)
    if (success) {
      const currentTime = Date.now()
      const expireTime = currentTime + 120000

      const timerKeyForUser = `${TIMER_KEY}_${email}`
      localStorage.setItem(timerKeyForUser, expireTime)
      setCounter(120)
    }
  }
  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
    }`
  }

  return (
    <React.Fragment>
      {counter === 0 ? (
        <a
          onClick={e => {
            handleResendClick(e)
          }}
          style={{
            cursor: 'pointer',
            color: '#0C172C',
            fontSize: '16px',
            textDecoration: 'underline',
            fontWeight: '700px',
          }}
        >
          <b>Resend verification email</b>
        </a>
      ) : (
        <b style={{ color: '#4F5B94', fontWeight: '400' }}>
          Wait {formatTime(counter)} to resend
        </b>
      )}
    </React.Fragment>
  )
}

export default ResendEmailTimer
